import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { useSelector } from 'react-redux';
import { SetOfAssessments } from 'src/modules/assessments/components/SetOfAssessments';
import { FlowType } from 'src/modules/assessments/models/assessments';
import { getMostRecentCareRecommendation } from 'src/modules/user/selectors/userSelectors';

import { BrandWrapper } from '../components/BrandWrapper';
import { isOnboardingFirstStepCompleted } from '../selectors/onboardingSelectors';

export const OnboardingSurveyStepPage: React.FC<RouteComponentProps> = ({ history }) => {
    const onboardingFirstStepCompleted = useSelector(isOnboardingFirstStepCompleted);
    const careRecommendationUuid = useSelector(getMostRecentCareRecommendation)?.uuid || undefined;

    const handleAssessmentsSubmit = () => {
        history.push('/pick-your-type-of-care');
    };

    useEffect(() => {
        // The second step of onboarding will be
        // marked as "completed" part way through
        // this page's flow once the user completes
        // the WHO5 assessment, if the first step of
        // onboarding is _not_ completed when
        // navigating to this page, return them
        // to onboarding.
        if (!onboardingFirstStepCompleted) {
            history.replace('/onboarding');
        }
    }, [history, onboardingFirstStepCompleted]);

    if (!onboardingFirstStepCompleted) {
        return null;
    }

    return (
        <BrandWrapper>
            <SetOfAssessments
                onSubmit={handleAssessmentsSubmit}
                flowType={FlowType.INITIAL_ONBOARDING}
                startAssessmentFlowVariables={{ careRecommendationUuid }}
            />
        </BrandWrapper>
    );
};
